module.exports = __webpack_public_path__ + "media/images/tag-banner-423271df8f84ad0cdaa18f20e4891f2b.jpeg";